import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex, Icon } from 'Components/UI/_Legacy'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import arrowLeftLongGlyph from 'Assets/_Legacy/Svg/arrow-left-long.svg'

import {
  SLIDE_CONTAINER_WIDTH,
  SLIDE_IMAGE_HEIGHT,
  SLIDE_IMAGE_WIDTH,
} from 'Constants/Swipers'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex)`
  justify-content: center;
  align-items: center;
`

const backgroundColorCss = ({ backgroundColor }) =>
  backgroundColor &&
  css`
    background-color: ${props => props.backgroundColor};
  `

export const Wrapper = styled(Flex)
  .attrs({
    width: SLIDE_CONTAINER_WIDTH,
    height: [280, 360, 360, 450],
    px: [30, 30, 30, 40],
    pt: [30, 30, 30, 40],
  })
  .withConfig({
    shouldForwardProp,
  })`
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  border-radius: 20px;

  ${backgroundColorCss}
`

export const Header = styled(Flex)
  .attrs({
    flexDirection: ['column', 'row'],
    alignItems: ['flex-start', 'center'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  width: 100%;
  justify-content: space-between;
`

export const HeaderIcon = styled(Icon).attrs({
  glyph: arrowLeftLongGlyph,
  size: [20, 20, 20, 30],
})`
  fill: ${themeGet('colors.white')};
  transform: rotateZ(180deg);
  padding-right: 15px;
`

export const ImageHolder = styled(Flex)
  .attrs({
    width: SLIDE_IMAGE_WIDTH,
    height: SLIDE_IMAGE_HEIGHT,
  })
  .withConfig({
    shouldForwardProp,
  })`
  margin-top: 34px;

  > div {
    height: 100%;
  }
  img {
    height: auto;
    width: 100%;
    object-fit: contain;
  }
`

export const ProjectLink = styled.div`
  cursor: pointer;
  text-decoration: none;
`
